import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Icon from "../custom-widgets/icon";

import styles from "./search-bar.module.scss";

const SearchBar = ({
  query = "",
  onClearQuery = () => {},
  onInputChange = () => {},
  onInputKeyDown = () => {},
  onSearchButtonClick = () => {},
  onFocus = () => {},
  id = "ssi",
  idSuffix = "",
  label = "Search",
  shouldFocus = false,
  shouldFocusCallback = () => {},
  isModal = false,
  isBankerSearch = false
}) => {
  const [focus, setFocus] = useState(false);
  const [focusWithin, setFocusWithin] = useState(false);
  const [searchButtonFocus, setSearchButtonFocus] = useState(false);
  const searchRef = useRef(null);
  const clear = (e) => {
    e.preventDefault();
    searchRef.current.focus();
    onInputChange({ target: { value: "" } });
    onClearQuery();
  };

  const searchInputId = `${id}-search-input${idSuffix ? `-${idSuffix}` : ""}`;
  const clearTextButtonId = `${id}-clear-text-button${idSuffix ? `-${idSuffix}` : ""}`;
  const searchButtonId = `${id}-search-button${idSuffix ? `-${idSuffix}` : ""}`;

  const defaultOnFocus = (e) => {
    setFocus(true);
    setFocusWithin(true);
    onFocus();
  };
  const defaultOnBlur = () => {
    setFocus(false);
    setFocusWithin(false);
  };

  useEffect(() => {
    if (shouldFocus) {
      searchRef.current.focus();
      shouldFocusCallback();
    }
  }, [shouldFocus, shouldFocusCallback]);

  return (
    <div
      className={`${styles.searchInputContainer} input-group ${isModal ? styles.searchInputContainerModal : ""} ${
        focus ? styles.searchInputContainerFocused : ""
      } ${focusWithin ? styles.searchInputContainerFocusWithin : ""}`}
    >
      <input
        id={searchInputId}
        type="text"
        className={`form-control ${styles.searchInput}`}
        aria-label={label}
        ref={searchRef}
        aria-describedby={searchInputId}
        value={query}
        onChange={onInputChange}
        onKeyDown={onInputKeyDown}
        onFocus={defaultOnFocus}
        onBlur={defaultOnBlur}
        label={label}
      />
      <button
        id={clearTextButtonId}
        onClick={clear}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        className={styles.buttonClearText}
      >
        <Icon name="times" class="fa-md text-secondary" />
      </button>
      <button
        onClick={onSearchButtonClick}
        className={`btn btn-primary no-min-width ${styles.buttonSearch} ${
          searchButtonFocus ? styles.buttonSearchFocused : ""
        }`}
        id={searchButtonId}
        onFocus={() => {
          setFocus(true);
          setSearchButtonFocus(true);
        }}
        onBlur={() => {
          setFocus(false);
          setSearchButtonFocus(false);
        }}
      >
        {isBankerSearch ? <p className="mb-0 fw-bold">Go</p> : <Icon name="search" class="fa-lg" />}
        <span className="sr-only">Search</span>
      </button>
    </div>
  );
};

export default SearchBar;

SearchBar.propTypes = {
  query: PropTypes.string.isRequired,
  clearQuery: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onInputKeyDown: PropTypes.func.isRequired,
  onSearchButtonClick: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  id: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  label: PropTypes.string.isRequired,
  shouldFocus: PropTypes.bool,
  shouldFocusCallback: PropTypes.func,
  isModal: PropTypes.bool,
  isBankerSearch: PropTypes.bool
};

